import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client — handles all server state (employee list, attendance records, etc.).
 * Never put API response data into Redux; this cache is the single source of truth for server data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // 30s before background refetch
      gcTime: 5 * 60 * 1000,       // 5min before cache garbage collected
      retry: 2,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
